import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useBundle } from '@amzn/react-arb-tools';
import { RufusIcon } from './RufusIcon';
export var RufusHeaderSize;
(function (RufusHeaderSize) {
    RufusHeaderSize["SMALL"] = "SMALL";
    RufusHeaderSize["LARGE"] = "LARGE";
})(RufusHeaderSize || (RufusHeaderSize = {}));
export const RufusWidgetHeader = ({ headerSize }) => {
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    if (isBundleLoading)
        return null;
    return (_jsx(Column, { spacingInset: "none", children: _jsxs(Row, { spacing: "200", children: [_jsx("div", { children: _jsx(RufusIcon, {}) }), _jsx(Text, { type: headerSize === RufusHeaderSize.SMALL ? 'b200' : 'h200', children: bundle.getMessage('askRufus') })] }) }));
};
